import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ball, BallComponent } from '../ball/ball.component';

@Component({
  selector: 'lib-rolling-balls',
  imports: [CommonModule, BallComponent],
  templateUrl: './rolling-balls.component.html',
  styleUrl: './rolling-balls.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RollingBallsComponent {
  // TODO: size input with host binding to sizing class names
  readonly ball = (Math.floor(Math.random() * 15) + 1) as Ball;
}
